// src/components/ContactForm.js
import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from "@mui/material";

import "./ContactForm.css";

export default function ContactForm() {
  const [state, handleSubmit] = useForm("xreavgzy");

  React.useEffect(() => {
    if (state.succeeded && typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", {
        method: "Formspree",
      });
    }
  }, [state.succeeded]);

  

  // Nice success state
  if (state.succeeded) {
    return (
      <Paper className="bws-formCard" elevation={0}>
        <Stack spacing={1.25}>
          <Typography variant="h2" className="bws-formTitle">
            Message sent
          </Typography>
          <Alert severity="success" className="bws-formAlert">
            Thanks — We got your message and will reply as soon as possible.
          </Alert>
          <Typography className="bws-formMuted">
            If you don’t hear back within 24 hours, feel free to email directly at{" "}
            <a className="bws-inlineLink" href="mailto:nate.parish@brainwavesolutions.net">
              nate.parish@brainwavesolutions.net
            </a>
            .
          </Typography>
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper className="bws-formCard" elevation={0}>
      <form onSubmit={handleSubmit} className="bws-form">
        <Stack spacing={2}>
          <Box>
            <Typography variant="h2" className="bws-formTitle">
              Send a message
            </Typography>
            <Typography className="bws-formMuted">
            We typically respond to messages within 24 hours.
            </Typography>
          </Box>

          {/* Name (optional but helpful) */}
          <TextField
            label="Name"
            name="name"
            autoComplete="name"
            fullWidth
            className="bws-textField"
          />

          {/* Email */}
          <TextField
            label="Email"
            id="email"
            type="email"
            name="email"
            autoComplete="email"
            required
            fullWidth
            className="bws-textField"
          />
          <div className="bws-formError">
            <ValidationError prefix="Email" field="email" errors={state.errors} />
          </div>

          {/* Message */}
          <TextField
            label="Message"
            id="message"
            name="message"
            required
            fullWidth
            multiline
            minRows={6}
            placeholder="Brief context, desired outcome, timeline, constraints…"
            className="bws-textField"
          />
          <div className="bws-formError">
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </div>

          {/* Optional hidden subject (nice for inbox organization) */}
          <input type="hidden" name="subject" value="Website contact — Brainwave Solutions" />

          {/* Submit */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25} alignItems={{ sm: "center" }}>
            <Button
              type="submit"
              variant="contained"
              className="bws-btn"
              disabled={state.submitting}
            >
              {state.submitting ? "Sending..." : "Send message"}
            </Button>

            <Typography className="bws-formMutedSmall" sx={{pl:"50px"}}>
              Prefer email? Please send to: {" "}
              <a className="bws-inlineLink" href="mailto:nate.parish@brainwavesolutions.net">
                nate.parish@brainwavesolutions.net
              </a>
            </Typography>
          </Stack>

          {/* If Formspree returns form-level errors */}
          {state.errors && state.errors.length > 0 && (
            <Alert severity="error" className="bws-formAlert">
              Please fix the highlighted fields and try again.
            </Alert>
          )}
        </Stack>
      </form>
    </Paper>
  );
}